import moment from "moment";

export function stringToDate(stringDate) {
    const w = moment(stringDate).format();
    return new Date(w);
}
